<div class="layout-menu-container" (click)="app.onSidebarClick($event)">
    <div *ngIf="currentUser" class="layout-menu-wrapper">
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true" [mega]="false" [showItem]="hasAccess(item)"></li>
        </ul>
   </div>
</div>
